import { Agent } from '@nemuru-eng/js-api-client';
import { SWRConfig } from 'swr';

import { ConfigurationForm } from '@/components/modules/AgentDetail/AgentDetails/components/Configuration/components/ConfigurationForm';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { useDialog } from '@/components/shared/hooks/useDialog';

import { ConfigurationEditDialog } from './components/ConfigurationEditDialog';

export const Configuration = ({
  currentAgent,
  editModeAllowed,
}: {
  currentAgent: Agent;
  editModeAllowed?: boolean;
}) => {
  const { opened, toggleDialog, setOpened } = useDialog();
  const toggleEditModeDialog = editModeAllowed && currentAgent ? toggleDialog : undefined;

  return (
    <SubSectionWrapper title={'CONFIGURATION'} toggleEditModeDialog={toggleEditModeDialog}>
      {!currentAgent ? (
        <PendingDataWarning />
      ) : (
        <>
          <ConfigurationForm currentAgent={currentAgent} fieldVariant={FieldVariant.dataRow} />
          <SWRConfig value={{ revalidateOnMount: false }}>
            <ConfigurationEditDialog
              opened={opened}
              setOpened={setOpened}
              toggleDialog={toggleDialog}
              currentAgent={currentAgent}
            />
          </SWRConfig>
        </>
      )}
    </SubSectionWrapper>
  );
};
